<template>
  <div>
    <div class="container-fluid page-head-wrap">
      <div class="container page-head">
        <h3 class="h5 text-center">
          <trans-text i18nKey="ui[92][1]" :isHtml="true"/>
        </h3>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="offset-md-2 col-md-8 px-md-5">
          <page-form></page-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {dd,store,app} from 'systems/imports'

  import PageForm from "page/partials/Unsupported/PageForm.vue"

  export default {
    name:"Unsupported",
    components: {
      PageForm,
    },
    data () {
      return {
      }
    },
    created(){
    },
    mounted(){
      this.$nextTick(vm => {
        setTimeout(()=>{
          $("#HeaderRightMenuList").css("visibility","hidden")
          $("#footer-nav").css("visibility","hidden")
        },500)

      })
    },
    beforeRouteLeave (to, from, next) {
      $("#HeaderRightMenuList").css("visibility","visible")
      $("#footer-nav").css("visibility","visible")
      next()
    },

    methods:{
    }
  }
</script>


<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// Unsupported.vue?8a491bba